<template>
  <div>
    <v-text-field
      v-model="textModel"
      :id="id"
      :name="name"
      :label="label"
      :placeholder="placeholder"
      @input="textInput"
      :rules="inputRules"
      :outline="outline"
      :round="round"
      :success-messages="successMessage"
      :error-messages="errorMessage"
      :disabled="disabled"
    >
      <template slot="append">
        <v-icon @click="showItems = !showItems" style="font-size: 30px;">
          {{ showItems ? 'arrow_drop_up' : 'arrow_drop_down' }}
        </v-icon>
        <v-icon @click="clear">{{ $vuetify.icons.close }}</v-icon>
      </template>
      <template v-slot:append-outer>
        <slot name="append-outer"></slot>
        <slot name="append-initial"></slot>
      </template>
    </v-text-field>
    <v-menu
      v-model="showItems"
      nudge-top="76"
      full-width
      :min-width="minWidthDropdown"
    >
      <template slot="activator">
        <div></div>
      </template>
      <v-list
        v-if="foundItems.length"
        :style="'max-height:' + heightDropdown + 'px; overflow-y: auto; -webkit-overflow-scrolling: touch;'"
        class="scroll-y"
        @touchmove.prevent
      >
        <v-list-tile v-for="(item, index) in foundItems" :key="index" @click="() => updateModel(item)">
          <v-list-tile-title>{{ item[itemText] }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
      <v-list
        v-else
        :style="'overflow-y: auto; -webkit-overflow-scrolling: touch;'"
        class="scroll-y"
        @touchmove.prevent
      >
        <v-list-tile>
          <v-list-tile-title>Empty list</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>

export default {
  name: 'EditableSelect',
  props: {
    id: {
      required: false,
      type: String,
      default: 'editableSelect',
    },
    name: {
      required: false,
      type: String,
      default: 'editableSelect',
    },
    label: {
      required: true,
      type: String,
    },
    itemList: {
      type: Array,
      required: true,
    },
    itemText: {
      type: String,
      required: true,
    },
    additionalSearchField: {
      type: String,
      required: false,
      default: ''
    },
    itemName: {
      type: String,
      required: true,
    },
    heightDropdown: {
      type: String,
      required: false,
      default: '200',
    },
    outline: {
      type: Boolean,
      required: false,
      default: false,
    },
    round: {
      type: Boolean,
      required: false,
      default: false,
    },
    minWidthDropdown: {
      type: String,
      required: false,
      default: '50%',
    },
    lengthForSearch: {
      type: Number,
      required: false,
      default: 1,
    },
    successMessage: {
      required: false,
      default: ''
    },
    errorMessage: {
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
    placeholder: {
      required: false,
      default: 'Select...'
    },
  },
  data() {
    return {
      showItems: false,
      textModel: '',
    }
  },
  computed: {
    inputRules() {
      const elem = this.itemList.find((item) => {
        return this.textModel === item[this.itemText];
      });
      return [
        v => !!v || this.itemName + ' is required',
        v => v.length >= this.lengthForSearch || `${this.itemName} must be more than ${this.lengthForSearch} characters`,
        () => !!this.successMessage || !!elem || 'Select ' + this.itemName + ' from list'
      ];
    },
    foundItems() {
      return this.itemList.filter(item => {
        let secondCondition = false;

        if (this.additionalSearchField && typeof item[this.additionalSearchField] !== 'undefined' && item[this.additionalSearchField]) {
          secondCondition = item[this.additionalSearchField].toLowerCase().includes(this.textModel.toLowerCase())
        }

        return item[this.itemText].toLowerCase().includes(this.textModel.toLowerCase()) || secondCondition;
      });
    }
  },
  watch: {
    value() {
      this.setModel(this.value);
    }
  },
  created() {
    this.setModel(this.value);
  },
  methods: {
    updateModel(item) {
      this.textModel = item[this.itemText];
      this.$emit('input', item);
      this.$emit('selected');
    },
    clear() {
      this.textModel = '';
      this.$emit('input', null)
    },
    setModel(value) {
      this.textModel = (value && value.id && value[this.itemText]) ? value[this.itemText] : this.textModel;
    },
    textInput() {
      this.showItems = this.textModel.length >= this.lengthForSearch;
      const item = this.itemList.find((item) => {
        return this.textModel === item[this.itemText];
      });
      if (item) {
        this.updateModel(item);
      } else {
        this.$emit('input', '');
      }
      this.$emit('textInput', this.textModel);
    },
    setTextModel(val) {
      this.textModel = val;
    }
  },
}
</script>